import React from 'react';
import PageHeader from '../../components/PageHeader';
import RegisterComponent from './RegisterComponent';
import { useTranslation } from 'react-i18next';

const Register = () => {

    const {t} = useTranslation();

    const tr = (key) => {
        return t(`register:${key}`);
    };

    const breadcrumbItems = [
        { label: tr('Home'), link: '/' },
        { label: tr('pageTitle'), link: '/register' }
    ];
    return (
        <div>
            <PageHeader items={breadcrumbItems} pageTitle={tr('pageTitle')} />
            <div className="flex justify-center min-h-screen py-20">
                <div className="w-full max-w-md ">
                    <RegisterComponent tr={tr} />
                </div>
            </div>
        </div>
    );
};

export default Register;
